<!--一体化教研-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <home-manager-menu :item-num="this.activeItem"
                                       @change-item="changeItem"/>
                </div>

                <div v-if="activeItem==='1'"  class="right-content-container">
                    <topic-manager :item-mode="this.activeMode" @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='2'"  class="right-content-container">
                    <archive-manager :item-mode="this.activeMode" @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='3'"  class="right-content-container">
                    <race-manager :item-mode="this.activeMode" @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='4'"  class="right-content-container">
                    <activity-manager :item-mode="this.activeMode" @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='5'"  class="right-content-container">
                    <user-analyse-report :item-mode="this.activeMode" @change-mode="changeMode"/>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead";
import homeManagerMenu from "@/components/homeManager/homeManagerMenu";
import topicManager from "@/components/homeManager/topicManager.vue";
import archiveManager from "@/components/homeManager/archive/archiveManager.vue";
import raceManager from "@/components/homeManager/race/raceManager.vue";
import ActivityManager from "@/components/homeManager/activity/activityManager.vue";
import userAnalyseReport from "@/components/homeManager/report/userAnalyseReport.vue";
export default {
    components: {
        ActivityManager,
        archiveManager,
        homeHead,
        homeManagerMenu,
        topicManager,
        raceManager,
        userAnalyseReport
    },
    name: "homeManagerCenter",
    data() {
        return {
            pageMode:"list",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeManagerCenter",
            activeItem:"1",
            activeMode:"list",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>